import { Link, NavLink } from "react-router-dom";
import { LOGO } from "../../../config";
import { NAV_LINKS } from "./navlink";
import { useState } from "react";
import SubMenu from "./SubMenu";
import { AiOutlineLogout } from "react-icons/ai";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import { IoMdMenu } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import SubMenuMobile from "./SubMenuMobile";

const cookies = new Cookies();
const SideBar = () => {
  const navigate = useNavigate();
  const [isSubMenuId, setIsSubMenuId] = useState(null);
  const handleLogout = () => {
    sessionStorage.clear();
    navigate("/", { replace: true });
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Filter links based on user role
  const userRole = sessionStorage.getItem("roles");
  const filteredLinks = NAV_LINKS.filter(
    (item) => !item.allowedRoles || item.allowedRoles.includes(userRole)
  ).map((item) => {
    if (item.sub_link) {
      return {
        ...item,
        sub_link: item.sub_link.filter(
          (sub) => !sub.allowedRoles || sub.allowedRoles.includes(userRole)
        ),
      };
    }
    return item;
  });

  return (
    <>
      <aside className="shrink-0 w-[100px] h-screen left-0 bg-soft_gray z-20 lg:block hidden static lg:fixed">
        <div className=" relative z-30 overflow-y-scroll overflow-x-hidden h-full">
          <div className="p-4 border-b bg-white justify-center text-center">
            <Link className="font-semibold text-primary text-xl" to="/dashboard">
              <img src={LOGO} alt="" />
            </Link>
          </div>
          <div className=" bg-white h-full">
            {filteredLinks.map((navItem, navIdx) => {
              const { icon, screen, link, hasSubMenu } = navItem;
              return (
                <div key={navIdx} className="text-center">
                  {hasSubMenu ? (
                    <button
                      onClick={() => setIsSubMenuId(navIdx)}
                      className="hover:bg-gray-100 w-full py-3 inline-block relative z-30"
                    >
                      <div className="w-6 h-6 mx-auto">{icon}</div>
                      <span className="text-xs font-semibold uppercase">
                        {screen}
                      </span>
                    </button>
                  ) : (
                    <NavLink
                      onClick={() => setIsSubMenuId(null)}
                      to={link}
                      className={`w-full py-3 inline-block relative z-40 hover:bg-gray-100`}
                    >
                      <div className="w-6 h-6 mx-auto">{icon}</div>
                      <span className="text-xs font-semibold uppercase">
                        {screen}
                      </span>
                    </NavLink>
                  )}
                  <SubMenu
                    open={hasSubMenu && navIdx === isSubMenuId}
                    onClose={() => setIsSubMenuId(false)}
                    data={navItem}
                  />
                </div>
              );
            })}
            <button
              onClick={handleLogout}
              className="hover:bg-red-100 bg-red-500 w-full py-3 inline-block relative z-30"
            >
              <div className="w-6 h-6 mx-auto">
                <AiOutlineLogout className="w-full h-full text-white" />
              </div>
              <span className="text-xs font-semibold uppercase text-white">
                Logout
              </span>
            </button>
          </div>
        </div>
      </aside>
      <header className="flex lg:hidden fixed top-0 left-0 right-0 bg-soft_gray z-20 p-2 justify-between">
        <img src={LOGO} alt="" className="h-12 w-auto" />

        <button onClick={() => setIsMenuOpen(true)}>
          <IoMdMenu className="w-8 h-8 text-neutral-900" />
        </button>
      </header>
      <div className="h-16"></div>

      {isMenuOpen && (
        <div className="flex z-50 fixed right-0 top-0 w-full">
          <div className="w-1/3 bg-black opacity-40 h-screen"></div>
          <nav className=" bg-white w-2/3 shadow-lg min-h-screen p-5">
            <button onClick={() => setIsMenuOpen(false)}>
              <IoClose className="w-8 h-8 text-neutral-900" />
            </button>
            {filteredLinks.map((navItem, navIdx) => {
              const { icon, screen, link, hasSubMenu } = navItem;
              return (
                <div key={navIdx} className="text-center w-full">
                  {hasSubMenu ? (
                    <button
                      onClick={() => {
                        setIsSubMenuId(isSubMenuId === navIdx ? null : navIdx);
                      }}
                      className="hover:bg-gray-100 flex items-center space-x-3 justify-start w-full py-3 relative z-30"
                    >
                      <div className="w-6 h-6">{icon}</div>
                      <span className="text-xs font-semibold uppercase">
                        {screen}
                      </span>
                    </button>
                  ) : (
                    <NavLink
                      onClick={() => {
                        setIsSubMenuId(null);
                        setIsMenuOpen(false);
                      }}
                      to={link}
                      className={`w-full py-3 flex items-center space-x-3 justify-start relative z-40 hover:bg-gray-100`}
                    >
                      <div className="w-6 h-6">{icon}</div>
                      <span className="text-xs font-semibold uppercase">
                        {screen}
                      </span>
                    </NavLink>
                  )}

                  <SubMenuMobile
                    open={hasSubMenu && navIdx === isSubMenuId}
                    data={navItem}
                    closeMenu={() => setIsMenuOpen(false)}
                  />
                </div>
              );
            })}
            <button
              onClick={handleLogout}
              className="hover:bg-red-100 flex items-center space-x-3 justify-start w-full py-3 relative z-30"
            >
              <div className="w-6 h-6">
                <AiOutlineLogout className="w-full h-full text-red-500" />
              </div>
              <span className="text-xs font-semibold uppercase text-red-500">
                Logout
              </span>
            </button>
          </nav>
        </div>
      )}
    </>
  );
};

export default SideBar;
